import { useMutation, useQuery } from 'react-query'
import { getInvoicingFunnelHistory, refreshInvoicingFunnelHistory } from './historyApi'

export const useInvoicingFunnelHistory = () => {
  return useQuery({
    queryKey: ['invoicingFunnelHistory'],
    queryFn: getInvoicingFunnelHistory,
  })
}

export const useInvoicingFunnelHistoryRefresh = () => {
  return useMutation({
    mutationFn: refreshInvoicingFunnelHistory,
  })
}
